import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { RightOutlined } from "@ant-design/icons";
import { useUserInfo } from "@/model";
import { hasPermission } from "@/utils";
import "./index.less";

import center_banner from "@/images/service/center_banner.png";
import center_be_shipped from "@/images/service/center_be_shipped.png";
import center_received from "@/images/service/center_received.png";
import center_frozened from "@/images/service/center_frozened.png";
import center_reconciliation from "@/images/service/center_reconciliation.png";
import center_bill from "@/images/service/center_bill.png";
import { serviceApi } from "@/apis";
import { message } from "antd";
// import center_feedback from "@/images/service/center_feedback.png";

const ServiceHome = () => {
  const userInfo = useUserInfo();
  const navigate = useNavigate();

  const [orderListPer, setOrderListPer] = useState(false); // 订单列表
  const [reconcilePer, setReconcilePer] = useState(false); // 对账函
  const [invoicePer, setInvoicePer] = useState(false); // 发票管理

  const [noticeList, setNoticeList] = useState<NoticeListItem[]>([]);
  const [orderWaitShipped, setOrderWaitShipped] = useState(0);
  const [orderFreeze, setOrderFreeze] = useState(0);
  const [statementNum, setStatementNum] = useState(0);
  const [invoiceNum, setInvoiceNum] = useState(0);

  // 先拿权限
  useEffect(() => {
    const permissionsList: string[] = [];
    if (userInfo.serviceMenuItems && userInfo.serviceMenuItems.children) {
      const dfs: (root: any) => void = (root) => {
        if (!root) return;
        const { resources, children = [] } = root;
        if (resources) {
          permissionsList.push(resources);
        }
        children.forEach((el: any) => {
          dfs(el);
        });
      };
      dfs(userInfo.serviceMenuItems);
      const isOrderListPer = hasPermission(
        permissionsList,
        "/service/orderList"
      );
      setOrderListPer(isOrderListPer);
      const isReconcilePer = hasPermission(
        permissionsList,
        "/service/reconcile"
      );
      setReconcilePer(isReconcilePer);
      const isInvoicePer = hasPermission(permissionsList, "/service/invoice");
      setInvoicePer(isInvoicePer);
    }
  }, [userInfo.serviceMenuItems]);

  // 获取相关数据
  useEffect(() => {
    if (!userInfo.curUserInfo) return;
    getNoticeList(userInfo.curUserInfo.customerCode);
    getTips(userInfo.curUserInfo.userAccount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.curUserInfo]);

  // 公告列表
  const getNoticeList = useCallback((customerCode: string) => {
    serviceApi
      .findByNoticeCustomerPageDto({
        customerCode,
        size: 5,
        page: 1,
      })
      .then((res) => {
        setNoticeList(res.records || []);
      })
      .catch((err) => {
        message.error(err);
      });
  }, []);

  const getTips = useCallback((userAccount: string) => {
    // 订单数量
    serviceApi
      .findNumberByConditions({
        account: userAccount,
        orderStatus: "waitShipped", // 待发货
        orderType: "ZOR1",
      })
      .then((res) => {
        setOrderWaitShipped(res);
      })
      .catch((err) => {
        message.error(err);
      });
    serviceApi
      .findNumberByConditions({
        account: userAccount,
        orderStatus: "freeze", // 冻结
        orderType: "ZOR1",
      })
      .then((res) => {
        setOrderFreeze(res);
      })
      .catch((err) => {
        message.error(err);
      });
    // 对账函
    serviceApi
      .findNoReaderByCustomerUser({
        account: userAccount,
        isRead: "1",
        size: 5,
        page: 1,
      })
      .then((res) => {
        setStatementNum(res);
      })
      .catch((err) => {
        message.error(err);
      });
    // 发票管理
    serviceApi
      .invoice_findByConditions({
        account: userAccount,
        isRead: "1",
        size: 5,
        page: 1,
      })
      .then((res) => {
        setInvoiceNum(res.total || 0);
      })
      .catch((err) => {
        message.error(err);
      });
    // 服务反馈
  }, []);

  const goPage = (path: string) => {
    navigate(path);
  };

  const goOrderList = (type: string) => {
    navigate("/service/orderList", {
      state: type,
    });
  };

  const goNoticeDetail = (id: string) => {
    navigate(`/service/announcement/detail`, {
      state: {
        id,
      },
    });
  };

  return (
    <article className="service-center">
      <section className="service-center-title service-center-box">
        <p>您好，{userInfo.curUserInfo?.customerName}，欢迎进入服务中心！</p>
      </section>
      <img
        className="banner-image"
        style={{ width: "100%", marginBottom: "10px" }}
        src={center_banner}
        alt="服务中心banner"
      />
      {orderListPer && (
        <section className="service-center-box">
          <h3>
            我的订单
            <span onClick={() => goPage("/service/orderList")}>
              全部订单
              <RightOutlined />
            </span>
          </h3>
          <div className="flex">
            <div className="service-center-box-item flex-c-c">
              <div
                className="item-top"
                onClick={() => goOrderList("waitShipped")}
              >
                <img src={center_be_shipped} alt="待发货" />
                {orderWaitShipped ? <i>{orderWaitShipped}</i> : null}
              </div>
              <span>待发货</span>
            </div>
            <div className="service-center-box-item flex-c-c">
              <div
                className="item-top"
                onClick={() => goOrderList("completed")}
              >
                <img src={center_received} alt="已签收" />
                {/* <i>15</i> */}
              </div>
              <span>已签收</span>
            </div>
            <div className="service-center-box-item flex-c-c">
              <div className="item-top" onClick={() => goOrderList("freeze")}>
                <img src={center_frozened} alt="已冻结" />
                {orderFreeze ? <i>{orderFreeze}</i> : null}
              </div>
              <span>已冻结</span>
            </div>
          </div>
        </section>
      )}
      {(reconcilePer || invoicePer) && (
        <section className="service-center-box">
          <h3>我的待办</h3>
          <div className="flex">
            {reconcilePer && (
              <div className="service-center-box-item flex-c-c">
                <div
                  className="item-top"
                  onClick={() => goPage("/service/reconcile")}
                >
                  <img src={center_reconciliation} alt="对账函" />
                  {statementNum ? <i>{statementNum}</i> : null}
                </div>
                <span>对账函</span>
              </div>
            )}
            {invoicePer && (
              <div className="service-center-box-item flex-c-c">
                <div
                  className="item-top"
                  onClick={() => goPage("/service/invoice")}
                >
                  <img src={center_bill} alt="发票管理" />
                  {invoiceNum ? <i>{invoiceNum}</i> : null}
                </div>
                <span>发票管理</span>
              </div>
            )}
            {/* <div className="service-center-box-item flex-c-c">
            <div className="item-top">
              <img src={center_feedback} alt="服务反馈" />
            </div>
            <span>服务反馈</span>
          </div> */}
          </div>
        </section>
      )}
      <section className="service-center-bottom flex">
        <section className="service-center-box">
          <h3>
            公告
            <span onClick={() => goPage("/service/announcement")}>
              更多
              <RightOutlined />
            </span>
          </h3>
          <ul>
            {noticeList.map(({ id, title }) => (
              <li
                key={id}
                onClick={() => goNoticeDetail(id)}
                className="ellipsis"
              >
                <span>[ 公告 ]</span> {title}
              </li>
            ))}
          </ul>
        </section>
      </section>
    </article>
  );
};

export default ServiceHome;
